import { render, staticRenderFns } from "./layActiveHeader.vue?vue&type=template&id=04c606c7"
import script from "./layActiveHeader.vue?vue&type=script&lang=js"
export * from "./layActiveHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports